import { StatusBadge } from "@components/display/StatusBadge";
import { DataTableColumnHeader } from "@components/ui/data-table/DataTableColumnHeader";
import { STATUS } from "@features/rh/conges/config/statuses";
import { createColumn } from "@/lib/table/columnFactory";
import type { LeaveRequest } from "./types";

export const statutColumn = createColumn<LeaveRequest>({
  id: "statut",
  header: ({ column }) => <DataTableColumnHeader column={column} title="Statut" />,
  cell: ({ row }) => {
    const { etat, etatCode } = row.original;
    // Defensive: if the backend omitted the code, fall back to the API label.
    return (
      <StatusBadge status={etatCode ?? ""} config={STATUS} label={etatCode ? undefined : etat} />
    );
  },
});
